import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const ExpandIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.90944 9.77806C6.59702 10.0905 6.59702 10.597 6.90944 10.9094L11.4349 15.4349C11.7473 15.7473 12.2539 15.7473 12.5663 15.4349L17.0918 10.9094C17.4042 10.597 17.4042 10.0905 17.0918 9.77806C16.7794 9.46565 16.2728 9.46565 15.9604 9.77806L12.0006 13.7379L8.04081 9.77806C7.72839 9.46565 7.22185 9.46565 6.90944 9.77806Z"
            fill="currentColor"
        />
    </svg>
);